import { isOfMetaOrigin, isOfGoogleFlightsOrigin, isOfGoogleSearchWidgetOrigin, isOfKayakOrigin, isOfSkyScannerOrigin } from "../marketing-url-params.js";
import { customGoal, stage } from "@flights/et-universal";
const FLIGHTS_META_LANDINGS_V2_DESKTOP_AA_NAME = "flights_meta_landings_v2_desktop_aa";
const FLIGHTS_META_LANDINGS_V2_MOBILE_AA_NAME = "flights_meta_landings_v2_mdot_aa";
const trackMetaLandingsV2 = (stageNumber, type) => {
    const isMeta = isOfMetaOrigin();
    const expTypeToTrack = type === "desktop" ? FLIGHTS_META_LANDINGS_V2_DESKTOP_AA_NAME : FLIGHTS_META_LANDINGS_V2_MOBILE_AA_NAME;
    isMeta &&
        stage(expTypeToTrack, 1) &&
        stage(expTypeToTrack, stageNumber);
};
export const trackMetaChannelStagesV2 = (type) => {
    if (isOfGoogleFlightsOrigin()) {
        trackMetaLandingsV2(3, type);
    }
    else if (isOfKayakOrigin()) {
        trackMetaLandingsV2(2, type);
    }
    else if (isOfSkyScannerOrigin()) {
        trackMetaLandingsV2(4, type);
    }
    else if (isOfGoogleSearchWidgetOrigin()) {
        trackMetaLandingsV2(5, type);
    }
};
export const trackMetaLandingsCustomGoalsV2 = (goalNumber, type) => {
    const metaOrigin = isOfMetaOrigin();
    const expTypeToTrack = type === "desktop" ? FLIGHTS_META_LANDINGS_V2_DESKTOP_AA_NAME : FLIGHTS_META_LANDINGS_V2_MOBILE_AA_NAME;
    metaOrigin && customGoal(expTypeToTrack, goalNumber);
};
